<template>
  <div v-if="showDownloadSection" class="app-download text-center">
    <div class="wrapping-line text-center border-post-detail-15">
      <span class="background-post-background px-4">{{ $translate("common.or") }}</span>
    </div>

    <div class="d-flex justify-center my-4">
      <div v-if="configuration.appStoreUrl">
        <a
          :href="configuration.appStoreUrl"
          :aria-label="$translate('AppDownload.ariaDownloadOnAppStore')"
          class="store-badge"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img :src="appStoreImagePath" />
        </a>
      </div>
      <div v-if="configuration.googlePlayUrl" class="store-badge ml-4">
        <a
          :href="configuration.googlePlayUrl"
          :aria-label="$translate('AppDownload.ariaGetItOnGooglePlay')"
          class="store-badge"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img :src="googlePlayImagePath" />
        </a>
      </div>
    </div>
    <the-footer post-colors />
  </div>
</template>

<script>
import { mapState } from "pinia"
import { useConfigurationStore } from "@/store/configuration.js"

import appStoreImagePath from "@/assets/download-on-the-app-store.png"
import googlePlayImagePath from "@/assets/google-play-badge.png"

import TheFooter from "@/components/navs/TheFooter.vue"

export default {
  components: {
    TheFooter
  },
  data() {
    return {
      appStoreImagePath,
      googlePlayImagePath
    }
  },
  computed: {
    ...mapState(useConfigurationStore, ["configuration"]),
    showDownloadSection() {
      return this.configuration.appStoreUrl || this.configuration.googlePlayUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.app-download {
  .wrapping-line {
    width: 100%;
    line-height: 1px;
    border-bottom: 1px solid black;
    margin: 24px 0 16px;
  }

  img {
    max-width: 160px;
    height: 48px;
  }
}
</style>
